import { Image } from "antd";
import { useSearchParams } from "react-router-dom";
import LinkIcon from "../../../assets/images/external-link.png";
import PDF from "../../../assets/images/pdf.svg";
import { GetEmployeeDetailsResponseType } from "../../../types";
import { getExtension } from "../../../utils/string";
import InfoItem from "../../common/InfoItem";
import EditButtonEmployee from "./EditButtonEmployee";

type Props = {
  data?: GetEmployeeDetailsResponseType;
};

export default function AdditionalInformation({ data }: Props) {
  let [queryParams] = useSearchParams();
  const section_id = Number(queryParams.get("type"));

  const additionalData = data?.data?.employee?.additional_data?.filter(
    (el) => el?.additional_field?.section?.id === section_id
  );

  // console.log(data?.data?.employee?.additional_data);

  return (
    <ul>
      {additionalData?.map((item) => (
        <InfoItem title={item?.additional_field?.label} key={item?.id}>
          {item?.value ? (
            item?.additional_field?.type === "string" ? (
              item?.value
            ) : (
              <div className="flex items-end gap-2">
                <Image
                  src={getExtension(item?.value) === "pdf" ? PDF : item?.value}
                  width={40}
                  height={30}
                  className={
                    getExtension(item?.value) === "pdf"
                      ? "object-contain"
                      : "object-cover"
                  }
                  preview={getExtension(item?.value) !== "pdf"}
                />
                <span className="text-accent flex items-center gap-1 text-xs mt-1">
                  <a
                    href={item?.value}
                    target="_blank"
                    className="-mt-[2px] cursor-pointer"
                    rel="noreferrer"
                    download="Attachment"
                  >
                    <img className="size-3" src={LinkIcon} alt="" />
                  </a>{" "}
                </span>
              </div>
            )
          ) : null}
        </InfoItem>
      ))}
      {data?.data?.employee?.status !== "invited" && (
        <EditButtonEmployee type={section_id} />
      )}
    </ul>
  );
}
